import React, { Component } from "react"

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import es from 'date-fns/locale/es';

class FormDatePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tmpDate : "0000-00-00 00:00"
        };

        this.onDateChange = this.onDateChange.bind(this);
        this.onMobileChange = this.onMobileChange.bind(this);
        this.set = this.set.bind(this);

        const
            userLang = navigator.language || navigator.userLanguage,
            language = localStorage.getItem('lang') || userLang.substring(0, 2);
        
        this.language = (language === "es" ? es : null);
    }
    onDateChange(e, name) {
        this.setState({ [name]: e });
    }
    onMobileChange(e){
        const
            { type, value } = e.currentTarget ,
            currentDate = (type === "date" ? this.state.tmpDate.substr(11, 5) : this.state.tmpDate.substr(0, 10)),
            newValue = (type === "date" ? `${value} ${currentDate}` : `${currentDate} ${value}`),
            _date = newValue.substr(0, 10).split("-"),
            _hour = newValue.substr(11, 5).split(":"),
            newDate = new Date(_date[0], (_date[1] - 1), _date[2], _hour[0], _hour[1]);

        this.setState({
            tmpDate : newValue,
            [this.props.name] : newDate
        });
    }
    set(value){
        this.setState({ [this.props.name]: new Date(value)});
    }
    render() {
        const 
            { dateFormat = "MMMM dd, yyyy H:mm"} = this.props,
            isSmall = (window.innerWidth < 580);

        return (
            <div style={{width: "100%"}}>
                {(!isSmall) &&
                    <div style={{ width: "100%" }}>
                        <DatePicker
                            className="form-control"
                            onChange={e => this.onDateChange(e, this.props.name)}
                            selected={this.state[this.props.name]}
                            autoComplete="off"
                            showTimeSelect
                            minDate={new Date()}
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            allowSameDay={true}
                            locale={this.language}
                            dateFormat={dateFormat}
                        />

                        <div className="hide">
                            <DatePicker
                                name={this.props.name}
                                selected={this.state[this.props.name]}
                                showTimeSelect
                                allowSameDay={true}
                                dateFormat="yyyy-MM-dd HH:mm"
                            />
                    </div>
                    </div>
                }

                {
                    (isSmall) && 
                    <div className="mobile-date-picker">
                        <input type="date" onChange={this.onMobileChange} className="form-control" />
                        <input type="time" onChange={this.onMobileChange} className="form-control" />
                        <input type="hidden" value={this.state.tmpDate} name={this.props.name}/>
                    </div>
                }
            </div>
        );
    }
};

export default FormDatePicker;

